// extracted by mini-css-extract-plugin
export default {"userCardContents":"users-card-module__userCardContents--_m1zq"};